import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { LoginService } from '../services/login.service';
import { AccountDetails } from '../models/AccountDetail';

@Component({
  selector: 'app-auth-nav',
  templateUrl: './auth-nav.component.html',
  styleUrls: ['./auth-nav.component.css']
})
export class AuthNavComponent implements OnInit {
  isLoggedIn: boolean;
  firstName: string;
  acctDetails: AccountDetails;
  orgId: number;
  showMsg: boolean;
  showX: boolean;
  showPlus: boolean;
  constructor(private loginService: LoginService, private ref: ChangeDetectorRef) {
    setInterval(() => {
      this.setup();
    }, 500);
  }

  ngOnInit() {
    this.showMsg = true;
    this.showX = true;
    this.showPlus = false;
  }

  setup() {
    if (this.isLoggedIn == this.loginService.getIsLoggedIn()) {
      return;
    }
    this.isLoggedIn = this.loginService.getIsLoggedIn();
    this.loginService.getUserIsLoggedIn()
      .subscribe((login) => {
        if (login) {
          this.loginService.getCustomerAccountDetails()
            .subscribe((details: any) => {
              this.acctDetails = details;
              this.firstName = details[0].accountDetails.firstName;
              this.orgId = details[0].accountDetails.orgUnitId;
              this.ref.detectChanges();
            });
        }
      });
  }

  hideMsgX() {
    this.showMsg = false;
    this.showX = false;
    this.showPlus = true;
  }
  showMsgX() {
    this.showMsg = true;
    this.showPlus = false;
    this.showX = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/auth-nav/auth-nav.component.ts